import React from 'react';
import Icon from '@ant-design/icons';
import Utils from '../Utils';
import Analytics from '../services/Analytics';

/* eslint-disable max-len */
const commandIcon = () => {
	return (
		<svg x="0px" y="0px" width="18px" height="18px" fill="#f4364c">
			<g>
				<path d="M 12.902344 9.804688
						L 11.097656 9.804688 L 11.097656 6.195312 L 12.902344 6.195312
						C 14.609375 6.195312 16 4.804688 16 3.097656 C 16 1.390625 14.609375 0
						12.902344 0 C 11.195312 0 9.804688 1.390625 9.804688 3.097656 L 9.804688 4.902344
						L 6.195312 4.902344 L 6.195312 3.097656 C 6.195312 1.390625 4.804688 0 3.097656 0
						C 1.390625 0 0 1.390625 0 3.097656 C 0 4.804688 1.390625 6.195312 3.097656 6.195312 L 4.902344 6.195312
						L 4.902344 9.804688 L 3.097656 9.804688 C 1.390625 9.804688 0 11.195312 0 12.902344 C 0 14.609375 1.390625 16 3.097656 16
						C 4.804688 16 6.195312 14.609375 6.195312 12.902344 L 6.195312 11.097656 L 9.804688 11.097656 L 9.804688 12.902344
						C 9.804688 14.609375 11.195312 16 12.902344 16 C 14.609375 16 16 14.609375 16 12.902344 C 16 11.195312 14.609375 9.804688 12.902344 9.804688
						Z M 11.097656 3.097656 C 11.097656 2.101562 11.90625 1.292969 12.902344 1.292969 C 13.898438 1.292969 14.707031 2.101562 14.707031 3.097656 C 14.707031 4.09375 13.898438 4.902344 12.902344 4.902344 L 11.097656 4.902344 Z M 4.902344 12.902344 C 4.902344 13.898438 4.09375 14.707031 3.097656 14.707031 C 2.101562 14.707031 1.292969 13.898438 1.292969 12.902344 C 1.292969 11.90625 2.101562 11.097656 3.097656 11.097656 L 4.902344 11.097656 Z M 4.902344 4.902344 L 3.097656 4.902344 C 2.101562 4.902344 1.292969 4.09375 1.292969 3.097656 C 1.292969 2.101562 2.101562 1.292969 3.097656 1.292969 C 4.09375 1.292969 4.902344 2.101562 4.902344 3.097656 Z M 9.804688 9.804688 L 6.195312 9.804688 L 6.195312 6.195312 L 9.804688 6.195312 Z M 12.902344 14.707031 C 11.90625 14.707031 11.097656 13.898438 11.097656 12.902344 L 11.097656 11.097656 L 12.902344 11.097656 C 13.898438 11.097656 14.707031 11.90625 14.707031 12.902344 C 14.707031 13.898438 13.898438 14.707031 12.902344 14.707031 Z M 12.902344 14.707031 "
				/>
			</g>
		</svg>
	);
};

class Bookmark extends React.Component {
	componentDidMount = () => {
		window.addEventListener('keydown', this.onKeyDown);
	}
	componentWillUnmount = () => {
		window.removeEventListener('keydown', this.onKeyDown);
	}
	onKeyDown = event => {
		if ((Utils.isMacOS() && event.metaKey === true && event.keyCode === 68)
			|| (event.ctrlKey === true && event.keyCode === 68)) {
			Analytics.onBookmark();
		}
	}
	render = () => {
		const modifierKey = Utils.isMacOS() ?
			<Icon component={commandIcon} /> : 'Ctrl';
		return (
			<div className="bookmark">
				Like us? Press
				<span className="color-primary">
					{modifierKey} + D
				</span> to bookmark imagecompressor.io
			</div>
		);
	}
}

export default Bookmark;



// WEBPACK FOOTER //
// ./src/components/Bookmark.js